<template lang="pug">
  div
    v-card(flat)
      v-card-text.pa-2(v-if="isAdmin") Logged in as <strong>Admin</strong>
      v-card-text.pa-2(v-else) Logged in as <strong>{{coach.name}}</strong>
</template>

<script>
import { mapState } from 'vuex'

export default({
  computed: {
    ...mapState({
      coach: state => state.main.coach,
      isAdmin: state => state.auth.isAdmin
    })
  }
})
</script>